import Mutations from "./guest-upload-mutations";
import Actions from "./guest-upload-actions";
import Getters from "./guest-upload-getters";
const guestUploadStore = {
  namespaced: true,
  state: {
    classifications: {
      allIds: [],
      byId: {}
    },
    documents: {
      allIds: [],
      byId: {}
    },
    comments: {
      allIds: [],
      byId: {}
    },
    sampleDocuments: {
      allIds: [],
      byId: {}
    },
    token: "",
    clientDetails: {}
  },
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default guestUploadStore;